import { StyleSheet, Font } from "@react-pdf/renderer";

Font.register(
    {
        family: 'Noto Sans SC',
        fonts: [
            {
                src: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-300-normal.ttf',
                fontWeight: 300,
            },
            {
                src: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-400-normal.ttf',
                fontWeight: 400,
            },
            {
                src: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-500-normal.ttf',
                fontWeight: 500,
            },
            {
                src: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-700-normal.ttf',
                fontWeight: 700,
            }
        ]
    }
)

Font.register(
    {
        family: 'Noto Sans',
        fonts: [
            {
                src: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans@latest/latin-300-normal.ttf',
                fontWeight: 300,
            },
            {
                src: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans@latest/latin-400-normal.ttf',
                fontWeight: 400,
            },
            {
                src: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans@latest/latin-500-normal.ttf',
                fontWeight: 500,
            },
            {
                src: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans@latest/latin-700-normal.ttf',
                fontWeight: 700,
            }
        ]
    }
)

export const generalStyles = () => {

    const general = StyleSheet.create({
        pageStyles: {
            paddingTop: 20,
            paddingBottom:40,
            position: 'relative',
            fontFamily: 'ChineseFont',
            fontWeight:400,
        },
    })

    const blankSpaceFooter = StyleSheet.create({
        container: {
            minHeight:90,
            maxHeight:90,
            width: '90%',
            alignSelf: 'center',
            backgroundColor: 'white',
        }
    })

    const blankSpaceLatsFooter = StyleSheet.create({
        container: {
            minHeight:300,
            maxHeight:300,
            width: '90%',
            alignSelf: 'center',
            backgroundColor: 'white',
        }
    })


    const pageNumberAndTotalPages = StyleSheet.create({
        text: {
            position: 'absolute',
            bottom: 20,
            right: 25,
            fontSize: 5
        }
    })

    const pdfGenerationDate = StyleSheet.create({
        text: {
            position: 'absolute',
            bottom: 20,
            left: 25,
            fontSize: 5
        }
    })

    return {

        general,
        blankSpaceFooter,
        pageNumberAndTotalPages,
        pdfGenerationDate,
        blankSpaceLatsFooter
    }
}